const autocompleteFormParamEquipModel = {
  serviceTypes: 'Tipo de Serviço',
  frequency: 'Periodicidade',
  groups: 'Grupo',
};

export default autocompleteFormParamEquipModel;
